import { useEffect, useMemo } from "react";
import { Box } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import styles from "./styles";
import Pagination from "../../../common/Pagination";
import GTM from "../../../../utils/analytics/gtm";
import { ExamItem } from "../../../../types/common";

type ListItem = {
  examCentreId: string;
  examCentreName: string;
  examCentreAddress?: string;
  pageIndex: number;
  rows: Array<{ fullDetail: ExamItem } & Record<string, any>>;
};

const ExamList = ({
  pageText,
  list,
  columns,
  gotoPage,
}: {
  pageText: any;
  list: ListItem;
  columns: GridColDef[];
  gotoPage: (page: number) => void;
}) => {
  let visibleRows = useMemo(
    () => [...list.rows].splice(list.pageIndex * 10, 10),
    [list.pageIndex, list.rows]
  );

  useEffect(() => {
    GTM.viewExamList(
      list.examCentreId,
      list.examCentreName,
      visibleRows.map((item) => item.fullDetail)
    );
  }, [list.examCentreId, list.examCentreName, visibleRows]);

  return (
    <Box sx={styles.examCenter}>
      <Box className="upper_header">
        <Box className="label">
          {pageText?.labelsMetadata?.examCentreLabel}:
        </Box>
        <Box className="sub_label">
          {list.examCentreAddress
            ? `${list.examCentreName},${list.examCentreAddress}`
            : list.examCentreName}
        </Box>
      </Box>
      <Box sx={styles.gridTable}>
        <DataGrid rows={visibleRows} columns={columns} rowSelection={false} />
      </Box>
      <Pagination
        rows={list.rows}
        pageText={pageText}
        pageCount={list.rows.length / 10 + 1}
        pageIndex={list.pageIndex}
        gotoPage={gotoPage}
      />
    </Box>
  );
};

export default ExamList;
